import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getDataProjectsbyId } from "../helpers/fetchDataProject";
import CustButton from "../components/CustButton";

const DetailProject = ({ handleClose, handleShow }) => {
  const [content, setContent] = useState(null);

  const { id } = useParams();

  useEffect(() => {
    const initFetch = async () => {
      handleShow();
      try {
        const dataProjects = await getDataProjectsbyId(id);
        setContent(dataProjects);
        setTimeout(() => {
          handleClose();
        }, 500);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    window.scrollTo(0, 0);

    if (!content) {
      initFetch();
    }
  }, [content, handleClose, handleShow, id]);

  const { title, project_url, description, image_url } = content || {
    title: "DATA NOT FOUND",
    project_url: "",
    description: "",
    image_url: [],
  };

  return (
    <>
      <div
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/dr0lbokc5/image/upload/v1702146276/Group_37877_glv3ug.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          padding: "80px 0px",
        }}
      ></div>
      {content && (
        <Container className="d-flex flex-column justify-content-center align-items-center px-4">
          {image_url ? (
            <div className="d-flex flex-column col-10 gap-5 pb-5">
              <div className="w-100 d-flex justify-content-center">
                <img
                  src={image_url[0].image_url}
                  className="w-50"
                  alt="mainImg"
                />
              </div>
              <h2
                style={{
                  fontSize: "38px",
                  fontWeight: "bold",
                }}
              >
                {title}
              </h2>
              <p
                style={{
                  fontSize: "28px",
                  fontWeight: "normal",
                  color: "#757575",
                }}
              >
                {description}
              </p>
              <Row className="d-flex justify-content-start flex-wrap">
                {image_url.map((item, index) => {
                  return (
                    <Col key={index} className="col-6 p-3">
                      <div className="ratio ratio-1x1">
                        <img
                          src={item.image_url}
                          className="w-100"
                          alt="imgProject"
                        />
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          ) : (
            <div style={{
              padding: "65px 0px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}>
              <h1 className="text-center">DATA NOT FOUND</h1>
              <CustButton text={"Back To Home"} path={"/"} />
            </div>
          )}
        </Container>
      )}
    </>
  );
};

export default DetailProject;
